import axios from 'axios'

export default {
    namespaced: true,
    state: {
        financialAssistanceApplication: {},
    },
    mutations: {
        SET_FINANCIAL_ASSISTANCE_APPLICATION(state, payload) {
            state.financialAssistanceApplication = payload;
        },
    },
    actions: {
        async FetchFinancialAssistanceApplication({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload = HydratePayload(response.data.payload);

                            commit('SET_FINANCIAL_ASSISTANCE_APPLICATION', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFinancialAssistanceApplication: ${error.message}`));
            });
        },
        async InsertFinancialAssistanceApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertFinancialAssistanceApplication: ${error.message}`));
            });
        },
        async UpdateFinancialAssistanceApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/update`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateFinancialAssistanceApplication: ${error.message}`));
            });
        },
        async UpdateFinancialAssistanceApplicationBypassEvidenceFields({ }, obj) {
            obj.BypassEvidenceFields = StringifyJSON(obj.BypassEvidenceFields);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/update/bypass-evidence-fields`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateFinancialAssistanceApplicationBypassEvidenceFields: ${error.message}`));
            });
        },
        async UpdateFinancialAssistanceApplicationLastPageAccessed({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/update/last-page-accessed`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        //else reject(response.data.message);
                    }).catch(error => reject(`UpdateFinancialAssistanceApplicationLastPageAccessed: ${error.message}`));
            });
        },
        async SubmitFinancialAssistanceApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/submit`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`SubmitFinancialAssistanceApplication: ${error.message}`));
            });
        },
        async CancelFinancialAssistanceApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/cancel`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`CancelFinancialAssistanceApplication: ${error.message}`));
            });
        },
        async DeleteFinancialAssistanceApplication({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/financialassistance/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteFinancialAssistanceApplication: ${error.message}`));
            });
        },
    },
    getters: {
        FinancialAssistanceApplication(state) { return state.financialAssistanceApplication; },
    }
};

function HydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = CoalesceJSON(payload.benefitsReceived);
        payload.careExperienceTypes = CoalesceJSON(payload.careExperienceTypes);
        payload.discussApplicationPeople = CoalesceJSON(payload.discussApplicationPeople);
        payload.overrideEvidenceFields = CoalesceJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = CoalesceJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = CoalesceJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function DehydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = StringifyJSON(payload.benefitsReceived);
        payload.careExperienceTypes = StringifyJSON(payload.careExperienceTypes);
        payload.discussApplicationPeople = StringifyJSON(payload.discussApplicationPeople);
        payload.overrideEvidenceFields = StringifyJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = StringifyJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = StringifyJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function StringifyJSON(object) {
    if (object == null) return null;
    else if (typeof object == 'string') return object;
    else return JSON.stringify(object);
};
function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};

